module.exports = __webpack_public_path__ + "img/pareja.b416bc36.jpg";